/**
 * Constantes de contact pour CashLive
 * Centralisées pour faciliter les mises à jour
 */

export const CONTACT_INFO = {
    /** Numéro de téléphone principal */
    PHONE: '+33785990134',
    /** Numéro de téléphone formaté pour l'affichage */
    PHONE_DISPLAY: '+33 7 85 99 01 34',
    /** Email de contact principal */
    EMAIL: 'cashlive.contact@gmail.com',
    /** Email de support technique */
    SUPPORT_EMAIL: 'support@cashlive.fr',
} as const;

/**
 * Postes disponibles pour les contacts d'organisation
 */
export const CONTACT_POSITIONS = [
    { value: 'commercial', label: 'Commercial' },
    { value: 'sav', label: 'Service Après-Vente (SAV)' },
    { value: 'director', label: 'Directeur / Direction' },
    { value: 'manager', label: 'Responsable' },
    { value: 'assistant', label: 'Assistant(e)' },
    { value: 'other', label: 'Autre' },
] as const;
